<script>
import SkyList from 'sky-list';
import SkySearchMixin from 'sky-search/sky-search.mixin';

const parameters = {
	year: '',
	education: '',
	obsoleteEvents: false,
};

export default {
	props: ['api'],
	name: 'sky-news',
	mixins: [SkySearchMixin],
	data() {
		return {
			list: new SkyList({
				api: this.api,
				pagination: true,
			}, parameters),
			parameters,
		};
	},
	created() {
		/**
		 * Populate keywords from list in case it has intial value
		 * (from url string for instance)
		 */
		Object.keys(this.parameters).forEach((key) => {
			if (key in this.list.params) {
				this.parameters[key] = this.list.params[key];
			}
		});

		this.list.update();
	},
	watch: {
		parameters: {
			handler() {
				// Keep list params in sync
				Object.keys(this.parameters).forEach((key) => {
					if (this.list.params[key] !== this.parameters[key]) {
						this.list.params[key] = this.parameters[key];
						// Reset offset if params have changed
						this.list.params.offset = 0;
					}
				});
				this.update();
			},
			deep: true,
		},
	},
	methods: {
		update() {
			this.list.update();
		},
		more() {
			this.list.params.limit = this.list.params.limit + 10;
			this.update();
		},
	},
};
</script>

<style src="./sky-news.scss"></style>
<template src="./sky-news.html"></template>



// WEBPACK FOOTER //
// sky-news.vue?06887256